import React, { useContext, useRef } from "react";
import { useIntl } from "react-intl";
import Slider from "react-slick";

import {
  Root,
  Slide,
  Image,
  ContentContainer,
  Title,
  Desc,
  Actions,
  Arrows,
  Arrow,
  Card,
  Video,
} from "./HeroSlider.style";

import { UserContext } from "../../../context/UserContext";

import { Link } from "../../Link/Link";
import { Button } from "../../../ui/Button/Button";
import { Icon } from "../../../ui/Icon/Icon";
// import { LoyaltyCard } from "../../LoyaltyCard/LoyaltyCard";

import heroSlide1 from "../../../assets/images/homepage/hero/hp-hero-01-min.jpg";
import heroSlide2 from "../../../assets/images/homepage/hero/hp-hero-1a-Desktop.mp4";
import heroSlide2Mobile from "../../../assets/images/homepage/hero/hp-hero-1a-Mobile.mp4";
import heroSlide3 from "../../../assets/images/homepage/hero/hp-hero-02-min.jpg";
import heroSlide4 from "../../../assets/images/homepage/hero/hp-hero-03-min.jpg";
import heroSlide5 from "../../../assets/images/homepage/hero/hp-hero-05-min.jpg";
import strategies2026fnlsEnDesktop from "../../../assets/images/homepage/hero/strategies2026fnls/FNLS-EN-DESKTOP.jpg";
import strategies2026fnlsEnMobile from "../../../assets/images/homepage/hero/strategies2026fnls/FNLS-EN-MOBILE.jpg";
import strategies2026fnlsFrDesktop from "../../../assets/images/homepage/hero/strategies2026fnls/FNLS-FR-DESKTOP.jpg";
import strategies2026fnlsFrMobile from "../../../assets/images/homepage/hero/strategies2026fnls/FNLS-FR-MOBILE.jpg";
import fibreClinixEnDesktop from "../../../assets/images/homepage/hero/clinix-banners/CH-FiberClinix-Banner-DESKTOP-EN.png";
import fibreClinixFrDesktop from "../../../assets/images/homepage/hero/clinix-banners/CH-FiberClinix-Banner-DESKTOP-FR.png";
import fibreClinixEnMobile from "../../../assets/images/homepage/hero/clinix-banners/CH-FiberClinix-Banner-MOBILE-EN.png";
import fibreClinixFrMobile from "../../../assets/images/homepage/hero/clinix-banners/CH-FiberClinix-Banner-MOBILE-FR.png";
import traceyEnDesktop from "../../../assets/images/homepage/hero/tracey-banners/CH-Tracey-Banner-DESKTOP-EN.png";
import traceyFrDesktop from "../../../assets/images/homepage/hero/tracey-banners/CH-Tracey-Banner-DESKTOP-FR.png";
import traceyEnMobile from "../../../assets/images/homepage/hero/tracey-banners/CH-Tracey-Banner-MOBILE-EN.png";
import traceyFrMobile from "../../../assets/images/homepage/hero/tracey-banners/CH-Tracey-Banner-MOBILE-FR.png";
import valentinesEnDesktop from "../../../assets/images/homepage/hero/CH-Valentines-Banners/CH-Valentines-Banner-DESKTOP-EN.jpg";
import valentinesFrDesktop from "../../../assets/images/homepage/hero/CH-Valentines-Banners/CH-Valentines-Banner-DESKTOP-FR.jpg";
import valentinesEnMobile from "../../../assets/images/homepage/hero/CH-Valentines-Banners/CH-Valentines-Banner-MOBILE-EN.jpg";
import valentinesFrMobile from "../../../assets/images/homepage/hero/CH-Valentines-Banners/CH-Valentines-Banner-MOBILE-FR.jpg";
import iconsEnDesktop from "../../../assets/images/homepage/hero/icons/CH-Icons-Banner-DESKTOP-EN.jpg";
import iconsFrDesktop from "../../../assets/images/homepage/hero/icons/CH-Icons-Banner-DESKTOP-FR.jpg";
import iconsEnMobile from "../../../assets/images/homepage/hero/icons/CH-Icons-Banner-MOBILE-EN.jpg";
import iconsFrMobile from "../../../assets/images/homepage/hero/icons/CH-Icons-Banner-MOBILE-FR.jpg";

//fix club h logos
// add mobile video and photos

const settings = {
  arrows: false,
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000,
  speed: 800,
};

const getSlides = (intl) => {
  console.info({ locale: intl.locale });
  return [
    // {
    //   id: "valentines-banner-2026",
    //   aligned: "right",
    //   background: "light",
    //   images:
    //     intl.locale === "en-CA"
    //         ? [valentinesEnDesktop]
    //         : [valentinesFrDesktop],
    //   imagesMobile:
    //     intl.locale === "en-CA"
    //       ? [valentinesEnMobile]
    //       : [valentinesFrMobile],
    //   title: intl.formatMessage(
    //     {
    //       defaultMessage: "A LITTLE EXTRA LOVE FROM {br} CLUB H",
    //     },
    //     { br: <br /> }
    //   ),
    //   desc: intl.formatMessage(
    //     {
    //     defaultMessage:
    //       "Enjoy on 50% off on your favorites from Big Sexy Hair!{br} Live February 14 at 10AM ET {br} Ends February 16 at 10PM ET",
    //     },
    //     { br: <br /> }
    //   ),
    //   cta: {
    //     loggedIn: {
    //       label: intl.formatMessage({
    //         defaultMessage: "TREAT YOURSELF",
    //       }),
    //       url: "rewards?filters=%28brands%3A%21%28%276525b8b085b23b704a2d1913%27%29%2Ccategories%3A%21%28styling%29%29",
    //     },
    //     loggedOut: {
    //       label: intl.formatMessage({
    //         defaultMessage: "TREAT YOURSELF",
    //       }),
    //       url: "rewards?filters=%28brands%3A%21%28%276525b8b085b23b704a2d1913%27%29%2Ccategories%3A%21%28styling%29%29",
    //     },
    //   },
    // },
    {
      id: "icons-trip-2026",
      aligned: "right",
      background: "light",
      images:
        intl.locale === "en-CA"
            ? [iconsEnDesktop]
            : [iconsFrDesktop],
      imagesMobile:
        intl.locale === "en-CA"
          ? [iconsEnMobile]
          : [iconsFrMobile],
      title: intl.formatMessage(
        {
          defaultMessage: "Icon Tier Exclusive!",
        },
        { br: <br /> }
      ),
      desc: intl.formatMessage({
        defaultMessage:
          "Celebrate your ICON status with a curated unforgettable Italian escape alongside fellow salon owners.",
      }),
      cta: {
        loggedIn: {
          label: intl.formatMessage({
            defaultMessage: "REDEEM NOW",
          }),
          url: "/education/class/icons-getaway-2026-tuscany-italy",
        },
        loggedOut: {
          label: intl.formatMessage({
            defaultMessage: "REDEEM NOW",
          }),
          url: "/education/class/icons-getaway-2026-tuscany-italy",
        },
      },
    },
    {
      id: "fibre-clinix-2026",
      aligned: "right",
      background: "dark",
      images:
        intl.locale === "en-CA"
            ? [fibreClinixEnDesktop]
            : [fibreClinixFrDesktop],
      imagesMobile:
        intl.locale === "en-CA"
          ? [fibreClinixEnMobile]
          : [fibreClinixFrMobile],
      title: intl.formatMessage(
        {
          defaultMessage: "NEW! FIBRE CLINIX ",
        },
        { br: <br /> }
      ),
      desc: intl.formatMessage({
        defaultMessage:
          "The next level of bonding is here. Redeem your points to try the latest innovation.",
      }),
      cta: {
        loggedIn: {
          label: intl.formatMessage({
            defaultMessage: "REDEEM NOW",
          }),
          url: "/rewards?filters=%28brands%3A%21%28%276525b85c85b23b704a2d18d3%27%29%2Ctags%3A%21%28fibre-clinix%29%29",
        },
        loggedOut: {
          label: intl.formatMessage({
            defaultMessage: "REDEEM NOW",
          }),
          url: "/rewards?filters=%28brands%3A%21%28%276525b85c85b23b704a2d18d3%27%29%2Ctags%3A%21%28fibre-clinix%29%29",
        },
      },
    },
    // {
    //   id: "strategies2026FNLS",
    //   aligned: "right",
    //   background: "light",
    //   images:
    //     intl.locale === "en-CA"
    //       ? [strategies2026fnlsEnDesktop]
    //       : [strategies2026fnlsFrDesktop],
    //   imagesMobile:
    //     intl.locale === "en-CA"
    //       ? [strategies2026fnlsEnMobile]
    //       : [strategies2026fnlsFrMobile ],
    //   title: intl.formatMessage(
    //     {
    //       defaultMessage: "IN PERSON TRAINING EVENT",
    //     },
    //     { br: <br /> }
    //   ),
    //   // titleColor: "rgb(225, 0, 15)",
    //   desc: intl.formatMessage({
    //     defaultMessage:
    //       "Get the clarity you need to grow your business with purpose, strategy, and confidence.",
    //   }),
    //   cta: {
    //     loggedIn: {
    //       label: intl.formatMessage({
    //         defaultMessage: "RESERVE A SPOT",
    //       }),
    //       url: "/rewards?filters=%28categories%3A%21%28education%29%2Ctags%3A%21%28training-events%29%29",
    //     },
    //     loggedOut: {
    //       label: intl.formatMessage({
    //         defaultMessage: "RESERVE A SPOT",
    //       }),
    //       url: "/rewards?filters=%28categories%3A%21%28education%29%2Ctags%3A%21%28training-events%29%29",
    //     },
    //   },
    // },
    {
      id: "2",
      aligned: "right",
      background: "dark",
      video: heroSlide2,
      videoMobile: heroSlide2Mobile,
      title: intl.formatMessage({
        defaultMessage: "Top Brands, One Loyalty Club",
      }),
      desc: intl.formatMessage({
        defaultMessage:
          "Discover Henkel Beauty Care's elite brands in one loyalty program. Elevate your craft with rewards that matter. Welcome to Club H.",
      }),
      cta: {
        loggedIn: {
          label: intl.formatMessage({
            defaultMessage: "Shop Rewards",
          }),
          url: "/rewards",
        },
        loggedOut: {
          label: intl.formatMessage({
            defaultMessage: "Join Now",
          }),
          url: "/auth",
        },
      },
    },
    {
      id: "1",
      aligned: "right",
      background: "dark",
      images: [heroSlide1],
      title: intl.formatMessage({
        defaultMessage: "Rewards That Work as Hard as You Do",
      }),
      desc: intl.formatMessage({
        defaultMessage:
          "Membership to Club H is FREE – earn points for your Henkel beauty product purchases and invest them back into your craft. It's smart, simple, and designed for the pros.",
      }),
      cta: {
        loggedIn: {
          label: intl.formatMessage({
            defaultMessage: "Shop Rewards",
          }),
          url: "/rewards",
        },
        loggedOut: {
          label: intl.formatMessage({
            defaultMessage: "Join Now",
          }),
          url: "/auth",
        },
      },
    },
    // {
    //   id: "3",
    //   aligned: "right",
    //   background: "light",
    //   images: [heroSlide3],
    //   title: intl.formatMessage({
    //     defaultMessage: "IGORA VIBRANCE Relaunch Offer",
    //   }),
    //   desc: intl.formatMessage({
    //     defaultMessage:
    //       "Receive 6 new shades with purchase of  $200 of Igora Vibrance and get SAVE 21% + FREE Color Chart + 3000 Bonus Points!",
    //   }),
    //   cta: {
    //     loggedIn: {
    //       label: intl.formatMessage({
    //         defaultMessage: "VIEW OFFER",
    //       }),
    //       url: "/en-CA/offers/promo",
    //     },
    //     loggedOut: {
    //       label: intl.formatMessage({
    //         defaultMessage: "Join Now",
    //       }),
    //       url: "/auth",
    //     },
    //   },
    // },
    // {
    //   id: "4",
    //   aligned: "right",
    //   background: "light",
    //   images: [heroSlide4],
    //   title: intl.formatMessage({
    //     defaultMessage: "More Than Rewards – Join the Revolution",
    //   }),
    //   desc: intl.formatMessage({
    //     defaultMessage:
    //       "Club H celebrates your unique style. Connect, learn, and thrive in a community as creative and bold as you. Experience loyalty redefined.",
    //   }),
    //   cta: {
    //     loggedIn: {
    //       label: intl.formatMessage({
    //         defaultMessage: "Shop Rewards",
    //       }),
    //       url: "/rewards",
    //     },
    //     loggedOut: {
    //       label: intl.formatMessage({
    //         defaultMessage: "Join Now",
    //       }),
    //       url: "/auth",
    //     },
    //   },
    // },
    // {
    //   id: "fall2025-sale",
    //   aligned: "right",
    //   background: "light",
    //   images:
    //     intl.locale === "en-CA"
    //       ? [fall2025SaleEnDesktop]
    //       : [fall2025SaleFrDesktop],
    //   imagesMobile:
    //     intl.locale === "en-CA"
    //       ? [fall2025SaleEnMobile]
    //       : [fall2025SaleFrMobile],
    //   title: intl.formatMessage({
    //     defaultMessage: "CLUB H'S FIRST-EVER REWARDS SALE!",
    //   }),
    //   desc: intl.formatMessage(
    //     {
    //       defaultMessage:
    //         "Feast on Rewards! Enjoy our biggest Backbar Sale. Your favourite salon essentials for <b>75% fewer points</b>. Stock up and save big from  <b>October 13-17</b>.",
    //     },
    //     {
    //       b: (chunks) => <b>{chunks}</b>,
    //     }
    //   ),
    //   cta: {
    //     loggedIn: {
    //       label: intl.formatMessage({
    //         defaultMessage: "Shop Rewards",
    //       }),
    //       url: "/rewards?filters=%28tags%3A%21%28backbar-sale%29%29",
    //     },
    //     loggedOut: {
    //       label: intl.formatMessage({
    //         defaultMessage: "Join Now",
    //       }),
    //       url: "/auth",
    //     },
    //   },
    // },
    // {
    //   id: "newyear2025",
    //   aligned: "right",
    //   background: "light",
    //   images: [newYearSlide],
    //   // video: holidaySlide,
    //   // videoMobile: holidayMobile,
    //   title: intl.formatMessage(
    //     {
    //       defaultMessage: "HAPPY{br}NEW YEAR{br}FROM CLUB H",
    //     },
    //     { br: <br /> }
    //   ),
    //   titleColor: "rgb(225, 0, 15)",
    //   desc: intl.formatMessage({
    //     defaultMessage:
    //       "A new year means new possibilities. Start fresh and treat yourself to something special—your points are ready to make 2025 unforgettable!",
    //   }),
    //   cta: {
    //     loggedIn: {
    //       label: intl.formatMessage({
    //         defaultMessage: "Reward Yourself",
    //       }),
    //       url: "/rewards",
    //     },
    //     loggedOut: {
    //       label: intl.formatMessage({
    //         defaultMessage: "Reward Yourself",
    //       }),
    //       url: "/rewards",
    //     },
    //   },
    // },
    // {
    //   id: "5",
    //   aligned: "right",
    //   background: "light",
    //   images: [heroSlide5],
    //   title: intl.formatMessage({
    //     defaultMessage: "Sweep Into Style",
    //   }),
    //   desc: intl.formatMessage({
    //     defaultMessage:
    //       "Registering for Club H is your ticket to the sweepstakes. No additional steps are required, sign up by June 30th, 2024 and you're automatically entered to win one of 36 prizes featuring our color, styling and care products*.",
    //   }),
    //   cta: {
    //     loggedIn: {
    //       label: intl.formatMessage({
    //         defaultMessage: "Read more",
    //       }),
    //       url: "/sweepintostyle",
    //     },
    //     loggedOut: {
    //       label: intl.formatMessage({
    //         defaultMessage: "Read more",
    //       }),
    //       url: "/sweepintostyle",
    //     },
    //   },
    // },
    // {
    //   id: "4",
    //   aligned: 4,
    //   background: "dark",
    //   image: "https://picsum.photos/id/13/2800/1100",
    //   loyaltyCard: {
    //     tier: 1,
    //     pts: 27524,
    //     nextLvl: 28724,
    //     group: "Mat & Mat’s Group",
    //     userName: "Anna Meyer",
    //   },
    // },
  ];
};

export function HeroSlider() {
  const sliderRef = useRef();
  const { user } = useContext(UserContext);
  const intl = useIntl();
  const slides = getSlides(intl);

  const handlePrevSlide = () => {
    sliderRef.current.slickPrev();
  };

  const handleNextSlide = () => {
    sliderRef.current.slickNext();
  };

  const type4Slide = slides.find((slide) => slide.aligned === 4);
  const restSlides = slides.filter((slide) => slide.aligned !== 4);

  return (
    <Root>
      <Slider ref={sliderRef} {...settings}>
        {/* {user && type4Slide && (
          <Slide key={type4Slide.id}>
            <Image
              className={`--aligned-${type4Slide.aligned}`}
              src={type4Slide.image}
              alt=""
            />
            <Card>
              <LoyaltyCard
                tier={type4Slide.loyaltyCard.tier}
                pts={type4Slide.loyaltyCard.pts}
                memberSince={new Date()}
                group={type4Slide.loyaltyCard.group}
                userName={type4Slide.loyaltyCard.userName}
              />
            </Card>
          </Slide>
        )} */}

        {restSlides.map((slide) => {
          return (
            <Slide
              key={slide.id}
              className={`--aligned-${slide.aligned} --background-${slide.background}`}
            >
              {slide?.images?.length > 0 ? (
                <picture>
                  {slide?.imagesMobile?.length > 0 && (
                    <source
                      media="(max-width: 1023px)"
                      srcSet={slide.imagesMobile[0]}
                    />
                  )}
                  <Image
                    src={slide.images[0]}
                    alt={slide.title}
                    className={`--aligned-${slide.aligned}`}
                  />
                </picture>
              ) : (
                <Video autoPlay muted loop playsInline>
                  <source
                    src={slide.videoMobile}
                    media="(max-width: 1023px)"
                    type="video/mp4"
                  />
                  <source src={slide.video} type="video/mp4" />
                </Video>
              )}
              <ContentContainer
                className={`--aligned-${slide.aligned} --background-${slide.background}`}
              >
                <Title style={{ color: slide.titleColor }}>{slide.title}</Title>
                <Desc>{slide.desc}</Desc>
                {slide?.cta?.loggedIn && slide?.cta?.loggedOut && (
                  <Actions>
                    {user ? (
                      <Button as={Link} to={slide.cta.loggedIn.url}>
                        {slide.cta.loggedIn.label}
                      </Button>
                    ) : (
                      <Button as={Link} to={slide.cta.loggedOut.url}>
                        {slide.cta.loggedOut.label}
                      </Button>
                    )}
                    <Arrows>
                      <Arrow onClick={handlePrevSlide}>
                        <Icon icon="arrow-left-long" />
                      </Arrow>
                      <Arrow onClick={handleNextSlide}>
                        <Icon icon="arrow-right-long" />
                      </Arrow>
                    </Arrows>
                  </Actions>
                )}
              </ContentContainer>
              {/* {slide.aligned === "centered" && (
                <Image
                  className={`--aligned-${slide.aligned}`}
                  src={slide.images[1]}
                  alt=""
                />
              )} */}
            </Slide>
          );
        })}
      </Slider>
    </Root>
  );
}
